import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
addTranslationModal.$inject = ["ADMIN_URL", "API_URL", "$http", "$rootScope"];
angular.module('userApp').directive('addTranslationModal', addTranslationModal);

function addTranslationModal(ADMIN_URL, API_URL, $http, $rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: ADMIN_URL + '/templates/directives/settings/add-translation-modal.html',
    scope: {
      translationAdded: '=',
      showModal: '='
    },
    link: function () {
      var _link = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(scope, elem, attrs) {
        var throbber;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throbber = $rootScope.throbber;
                scope.createTranslation =
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  var _ref2, data;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          throbber.show();
                          _context.next = 4;
                          return $http.post("".concat(API_URL, "/api/v1/settings/translations"), {
                            key: scope.newKey,
                            translation: scope.newTranslation
                          });

                        case 4:
                          _ref2 = _context.sent;
                          data = _ref2.data;
                          throbber.hide('New label created');
                          scope.translationAdded();
                          $('#translation-modal').modal('hide');
                          _context.next = 14;
                          break;

                        case 11:
                          _context.prev = 11;
                          _context.t0 = _context["catch"](0);
                          throbber.showError("Sorry but an error occurred: ".concat(_context.t0.message));

                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this, [[0, 11]]);
                }));

                scope.showModal = function () {
                  scope.newKey = '';
                  scope.newTranslation = '';
                  $('#translation-modal').modal('show');
                };

                scope.cancel = function () {
                  $('#translation-modal').modal('hide');
                };

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function link(_x, _x2, _x3) {
        return _link.apply(this, arguments);
      };
    }()
  };
}